"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThemeToggle;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("linaria/react");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-env browser */
const Label =
/*#__PURE__*/
(0, _react2.styled)("label")({
  name: "Label",
  class: "Label_lok00ln",
  vars: {
    "lok00ln-0": [props => props.isDark ? '#6200ee' : '#000']
  }
});
const ThemeSwitchDiv =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "ThemeSwitchDiv",
  class: "ThemeSwitchDiv_ti2lwtw"
});
const Switch =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "Switch",
  class: "Switch_s120pijg"
});
const Input =
/*#__PURE__*/
(0, _react2.styled)("input")({
  name: "Input",
  class: "Input_i1midrh5"
});

function ThemeIcon({
  value
}) {
  if (value === 'dark') {
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "19",
      height: "20",
      viewBox: "0 0 50 50"
    }, React.createElement("path", {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "2",
      strokeLinejoin: "round",
      d: "M37,4a22,22 0 1,0 0,42a22,22 0 0,1 0-42z"
    }));
  } else if (value === 'light') {
    return React.createElement("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      width: "23",
      height: "22",
      fill: 'orange',
      viewBox: "0 0 130 130",
      enableBackground: "new 0 0 129 129"
    }, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
      d: "m64.5,92.6c15.5,0 28-12.6 28-28s-12.6-28-28-28-28,12.6-28,28 12.5,28 28,28zm0-47.9c11,0 19.9,8.9 19.9,19.9 0,11-8.9,19.9-19.9,19.9s-19.9-8.9-19.9-19.9c0-11 8.9-19.9 19.9-19.9z"
    }), React.createElement("path", {
      d: "m68.6,23.6v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1z"
    }), React.createElement("path", {
      d: "m60.4,105.6v12.9c0,2.3 1.8,4.1 4.1,4.1s4.1-1.8 4.1-4.1v-12.9c0-2.3-1.8-4.1-4.1-4.1s-4.1,1.8-4.1,4.1z"
    }), React.createElement("path", {
      d: "m96.4,38.5l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8 0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z"
    }), React.createElement("path", {
      d: "m23.5,105.6c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l9.1-9.1c1.6-1.6 1.6-4.2 0-5.8-1.6-1.6-4.2-1.6-5.8,0l-9.1,9.1c-1.6,1.6-1.6,4.2 0,5.8z"
    }), React.createElement("path", {
      d: "m122.5,64.6c0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.8,4.1 4.1,4.1h12.9c2.2,1.42109e-14 4.1-1.8 4.1-4.1z"
    }), React.createElement("path", {
      d: "m10.6,68.7h12.9c2.3,0 4.1-1.8 4.1-4.1 0-2.3-1.8-4.1-4.1-4.1h-12.9c-2.3,0-4.1,1.8-4.1,4.1 0,2.3 1.9,4.1 4.1,4.1z"
    }), React.createElement("path", {
      d: "m102.6,106.8c1,0 2.1-0.4 2.9-1.2 1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.9,1.2 2.9,1.2z"
    }), React.createElement("path", {
      d: "m38.4,38.5c1.6-1.6 1.6-4.2 0-5.8l-9.1-9.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l9.1,9.1c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2z"
    }))));
  } else {
    return null;
  }
}

function ThemeToggle() {
  const [isReady, setIsReady] = React.useState(false);
  const [isDark, setIsDark] = React.useState(false);
  React.useEffect(() => {
    if (isReady) {
      // Apply theme update to body if theme changes
      if (isDark) {
        document.body && document.body.classList.add('dark-theme');
      } else {
        document.body && document.body.classList.remove('dark-theme');
      }

      localStorage.setItem('preference-theme', isDark ? 'dark' : 'light');
    } else {
      // Correct the switch by reading theme from body on mount
      if (document.body && document.body.classList.contains('dark-theme')) {
        setIsDark(true);
      }

      setIsReady(true);
    }
  }, [isDark, isReady]);
  return React.createElement(ThemeSwitchDiv, null, React.createElement(Label, {
    isDark: isDark
  }, React.createElement(Input, {
    type: "checkbox",
    checked: isDark,
    disabled: !isReady,
    onChange: () => setIsDark(isDark => !isDark)
  }), React.createElement(Switch, null)), React.createElement(ThemeIcon, {
    value: isDark ? 'dark' : 'light'
  }));
}
//# sourceMappingURL=ThemeToggle.js.map

require('../css/src/templates/ThemeToggle.css');
